import * as yup from "yup";

const schema = yup.object().shape({
  firstName: yup
    .string()
    .required()
    .matches(/^(?!\s+$).+/, "Please provide valid values for First Name")
    .label("First Name"),
  lastName: yup
    .string()
    .required()
    .matches(/^(?!\s+$).+/, "Please provide valid values for Last Name")
    .label("Last Name"),
  department: yup.string().label("Department"),
  designation: yup.string().label("Designation"),
  email: yup.string().email().required().label("Business Email"),
  phone: yup
    .string()
    .required()
    .matches(/^[0-9]+$/, "Please enter a valid phone number")
    .min(10)
    .max(10)
    .label("Phone Number"),
  pickupAddress: yup.array().min(1).required().label("Pickup Address"),
  billingAddress: yup.array().min(1).required().label("Billing Address"),
  alternateContact: yup
    .string()
    .matches(/(^[0-9]+$|^$)/, "Please enter a valid phone number")
    //Making these changes for now
    .test("is valid", "Please enter a 10 digit contact number", (value) =>
      !value || (value && value.length) === 10 ? true : false
    )
    .min(0)
    //.max(10)
    .nullable(true)
    .label("Alternate Phone Number"),
  role: yup.string().required().label("User role"),
});

export default schema;
